<template>

    <div class="youtube-popin">
        <iframe width="100%" height="100%" :src="youtubeUrl" allow="autoplay" frameborder="0"></iframe>
    </div>

</template>

<script>

    import URI from 'urijs'
    // import $ from 'jquery'

    export default  {

        props: [ 'url' ],

        computed: {

            youtubeUrl: function() {
                let string = URI(this.url).search();
                let split = string.split("v=");
                let v = split[1];
                return 'https://www.youtube.com/embed/' + v + '?autoplay=1&rel=0&fs=1&loop=1&modestbranding=0&showinfo=0&controls=2&playsinline=1';
            }

        }

    }

</script>

<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .youtube-popin
        iframe
            width: 100%
            height: 500px
            +media("<=600px")
                height: 40vh
            +media("<=320px")
                height: 30vh

</style>
